import React from "react";
import ReactPlayer from "react-player";
import "./VideoHeader.scss";

function VideoHeader(props) {
  var headerStyle = "";
  
  if (window.innerWidth > 600) {
    headerStyle = "container-header-video";
  } else {
  //  var textStyle = "container-header-video";
  }
  return (
    <div className={headerStyle}>
      {!props.videoHeader ? (
        <div className="project-video">
          <img
            className="image-project"
            src={props.imgSrc}
            alt={props.imgSrc}
          />
        </div>
      ) : (
        <div className="project-video">
          {console.log(props.videoSrc)}
          <ReactPlayer
            url={props.videoSrc}
            playbackRate={1}
            width={`100%`}
            height={`auto`}
            playing={true}
            muted={false}
            loop={true}
            controls={true}
          />
        </div>
      )}
     
        <div className="text-row">
          <div className="project-title">
            <h3>{props.headerText.title}</h3>
            <p>{props.headerText.subTitle}</p>
          </div>
          <p className='description'>{props.headerText.description}</p>
          <div className='team'>
            <p>
              <b>Team :</b> <i>{props.headerText.team}</i>
            </p>
          </div>
         
        </div>
      </div>

  );
}

export default VideoHeader;
